import React, { Fragment, useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import { Col, Row, Card, CardBody, Input, Button, Form, InputGroup, InputGroupText } from "reactstrap";
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { useContext } from "react";
import Filter from "./Filter";
import Location from "./Location";
import JobTitleClass from "./JobTitle";
import Industry from "./Industry";
import SkillClass from "./Skill";
import FunctionalArea from "./FunctionalArea";
import EmploymentType from "./EmploymentType";
import Freshness from "./Freshness";
import VerificationFilter from "./VerificationFilter";
import Company from "./Company";
import { fetchJobsSearchRequest } from "../../../../redux/jobseeker/job_search/actions";
import { JobSearchContext } from "../../../../JobSearch/JobSearchContext";
import { fetchLocationsRequest } from "../../../../redux/location/actions";
import { customOptionsStyle } from "../../../../Constant";
import { experienceOptions } from "../../../../Constant";
import { useParams } from "react-router";
const Sidebar = ({ marginTop }) => {
  const dispatch = useDispatch(); // Initialize useDispatch hook
  const { companyId } = useParams();

  const [isOpen, setIsOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const { filters, clearFilters, updateFilters, pagePerpage } =
    useContext(JobSearchContext);
  const [formData, setFormData] = useState({
    keyword: "",
    experience: null,
    locations: [],
  });

  // Synchronize formData with filters context
  useEffect(() => {
    if (filters) { // Check if filters is defined
      setFormData({
        keyword: filters.keyword || "",
        experience: filters.experience || null,
        locations: filters.locations || [],
      });
    }
  }, [filters]);

  /**
   * location dropdown code start
   */
  //read location data from store
  const locationsReducerData = useSelector((state) => state.locationReducer);
  let locationData = [];
  if (!locationsReducerData.isLoading && locationsReducerData.data.data) {
    locationData = locationsReducerData.data.data;
  }

  const handleLocationFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchLocationsRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleLocationInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchLocationsRequest(inputValue));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  // Callback to handle location select change
  const handleLocationsChange = (selectedOptions) => {
    // Update the form state with selected values
    setErrors((prevErrors) => ({ ...prevErrors, locations: "" }));
    setFormData({ ...formData, locations: selectedOptions });
  };

  /**
   * location dropdown code end
   */

  const prevFiltersRef = useRef(null);
  const prevPaginationRef = useRef(null);

  useEffect(() => {
    if (filters) {
      const filtersString = JSON.stringify(filters);
      const paginationString = JSON.stringify(pagePerpage); // Track pagination separately

      // Dispatch only when filters or pagination change
      if (prevFiltersRef.current !== filtersString || prevPaginationRef.current !== paginationString) {
        prevFiltersRef.current = filtersString;
        prevPaginationRef.current = paginationString;

        console.log("Dispatching fetchJobsRequest with filters:", filters);

        const page = pagePerpage.page;
        const per_page = pagePerpage.per_page;

        const reqData = {
          keyword: filters.keyword || "",
          experience: filters.experience?.value || "",
          freshness: filters.freshness || 0,
          verified_status: filters.verified_status || "verified",
          locations: filters.locations?.map((loc) => loc.value).join(",") || "",
          industry_type: filters.industry_type?.map((loc) => loc.value).join(",") || "",
          employment_type: filters.employment_type?.map((loc) => loc.value).join(",") || "",
          functional_area: filters.functional_area?.map((loc) => loc.value).join(",") || "",
          skills: filters.skills?.map((loc) => loc.value).join(",") || "",
          company_id:
            companyId ||
            filters.company?.map((c) => c.value).join(",") ||
            "",
        };

        dispatch(fetchJobsSearchRequest(page, per_page, reqData));
      }
    }
  }, [filters, pagePerpage, dispatch, companyId]);

  const handleExperienceChange = (selectedOption) => {
    setErrors((prevErrors) => ({ ...prevErrors, experience: "" }));
    setFormData({ ...formData, experience: selectedOption });
  };

  const handleKeywordChange = (e) => {
    setErrors((prevErrors) => ({ ...prevErrors, keyword: "" }));
    setFormData({ ...formData, keyword: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      updateFilters(formData, true);
    }
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // if (formData.keyword.trim() === "") {
    //   errors.keyword = "Keyword is required";
    //   isValid = false;
    // }
    // if (!formData.experience) {
    //   errors.experience = "Experience is required";
    //   isValid = false;
    // }

    // if (formData.locations.length === 0) {
    //   errors.locations = "At least one location is required";
    //   isValid = false;
    // }
    setErrors(errors);
    return isValid;
  };

  const handleClearFilters = () => {
    setFormData({ ...formData, keyword: "", experience: null, locations: [] });
    clearFilters();
  };

  const handleClearKeyword = () => {
    setFormData({ ...formData, keyword: "" });

  };

  return (
    <Fragment>
      <Col sm="12">
        <Card style={{ marginTop: marginTop }}>
          <CardBody className="pb-3">
            <Form className="theme-form" onSubmit={handleSubmit}>
              <div className="row  justify-content-between">
                <div className="col-lg-4 col-md-4 col-sm-12 mb-3">
                  <div class="input-group mb-3">
                    <input value={formData.keyword}
                      onChange={handleKeywordChange} type="text" class="form-control form-control-sm" placeholder="Enter Keyword" aria-label="Enter Keyword" aria-describedby="basic-addon2" />
                    {formData.keyword && (<span onClick={handleClearKeyword} class="input-group-text" id="basic-addon2"><FaTimes className="text-muted" /></span>)}
                  </div>

                  {errors.keyword && (
                    <small className="text-danger">{errors.keyword}</small>
                  )}
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                  <Select
                    isMulti
                    options={locationData}
                    isLoading={locationsReducerData.isLoading}
                    placeholder="Select locations..."
                    value={formData.locations}
                    onChange={handleLocationsChange}
                    onInputChange={handleLocationInputChange}
                    styles={customOptionsStyle}
                    onFocus={handleLocationFocus}
                  />
                  {errors.locations && (
                    <small className="text-danger">{errors.locations}</small>
                  )}
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
                  <Select
                    options={experienceOptions}
                    value={formData.experience}
                    onChange={handleExperienceChange}
                    isSearchable
                    placeholder="Experience"
                  />
                  {errors.experience && (
                    <small className="text-danger">{errors.experience}</small>
                  )}
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12 mb-3">
                  <Button
                    color="primary"
                    style={{ width: "100%" }}
                    type="submit"
                  >
                    Search
                  </Button>
                </div>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>

      <Col xl="3" className="box-col-4 xl-30">
        <div className="md-sidebar">
          <Button
            onClick={(e) => setIsOpen(!isOpen)}
            color="primary"
            className="md-sidebar-toggle"
          >
            Job filter
          </Button>
          <div
            className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen && "open"
              } `}
          >
            <div className="" id="accordionoc">
              <Row>
                <Filter
                  onClearAll={handleClearFilters} // Pass a function to handle clearing filters
                />

                <Freshness />
                <VerificationFilter />
                <Location />
                <EmploymentType />

                <FunctionalArea />

                <SkillClass />
                <Industry />
                <Company />
                {/* <JobType /> */}
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default Sidebar;
